<template>
  <div>
    <h2>Begin Block {{ blocksCompleted + 1 }}</h2>
    <p>Here we go...</p>
    <div class="row">
      <div class="col">
        <button class="btn btn-secondary" @click="start">Start</button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button class="btn btn-secondary" @click="practice">Return to Practice</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      blocksCompleted: state => state.blocksCompleted
    })
  },
  methods: {
    ...mapActions(['shuffle', 'next']),
    start () {
      this.shuffle() // start the block by shuffling the trials
      this.next() // set the current trial
      this.$router.replace('/cue') // go to the cue state
    },
    practice () {
      this.$router.replace('/training')
    }
  }
}
</script>
